import { render, staticRenderFns } from "./AdditionProductSwiper.vue?vue&type=template&id=15f391d8&scoped=true"
import script from "./AdditionProductSwiper.vue?vue&type=script&lang=js"
export * from "./AdditionProductSwiper.vue?vue&type=script&lang=js"
import style0 from "./AdditionProductSwiper.vue?vue&type=style&index=0&id=15f391d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f391d8",
  null
  
)

export default component.exports